import React from 'react';
import { Table } from 'reactstrap';
import { TableWrapper } from './styles';
import { Tr, Td, P } from '../CheckProductAvailabilityModal/styles';

export const ClassInfoTable = ({ hidden, setHidden }) => {
  return (
    <TableWrapper
      hidden={hidden}
      onMouseOver={(event) => {
        setHidden(false);
      }}
      onMouseOut={(event) => {
        setHidden(true);
      }}
    >
      <Table style={{ border: '1px solid #e9ecef', borderRadius: '0.25rem' }}>
        <thead>
          <Tr>
            <th
              style={{
                whiteSpace: 'initial',
                textAlign: 'center',
                fontWeight: 'bold',
                padding: '0',
                backgroundColor: '#f6f9fc'
              }}
            >
              CLASSE:
            </th>

            <th
              style={{
                whiteSpace: 'initial',
                textAlign: 'center',
                fontWeight: 'bold',
                padding: '0',
                backgroundColor: '#f6f9fc'
              }}
            >
              CAPACIDADE DE ARMAZENAMENTO KG DE GLP:
            </th>

            <th
              style={{
                whiteSpace: 'initial',
                textAlign: 'center',
                fontWeight: 'bold',
                padding: '0',
                backgroundColor: '#f6f9fc'
              }}
            >
              CAPACIDADE DE ARMAZENAMENTO (EQUIVALENTE EM BOTIJÕES CHEIOS COM
              13KG DE GLP)*:
            </th>
          </Tr>
        </thead>
        <tbody>
          <Tr>
            <Td style={{ padding: '0' }}>I</Td>
            <Td style={{ padding: '0' }}>Até 520</Td>
            <Td style={{ padding: '0' }}>Até 40</Td>
          </Tr>

          <Tr>
            <Td style={{ padding: '0' }}>II</Td>
            <Td style={{ padding: '0' }}>Até 1.560</Td>
            <Td style={{ padding: '0' }}>Até 120</Td>
          </Tr>

          <Tr>
            <Td style={{ padding: '0' }}>III</Td>
            <Td style={{ padding: '0' }}>Até 6.240</Td>
            <Td style={{ padding: '0' }}>Até 480</Td>
          </Tr>

          <Tr>
            <Td style={{ padding: '0' }}>IV</Td>
            <Td style={{ padding: '0' }}>Até 12.480</Td>
            <Td style={{ padding: '0' }}>Até 960</Td>
          </Tr>

          <Tr>
            <Td style={{ padding: '0' }}>V</Td>
            <Td style={{ padding: '0' }}>Até 24.960</Td>
            <Td style={{ padding: '0' }}>Até 1.920</Td>
          </Tr>

          <Tr>
            <Td style={{ padding: '0' }}>VI</Td>
            <Td style={{ padding: '0' }}>Até 49.920</Td>
            <Td style={{ padding: '0' }}>Até 3.840</Td>
          </Tr>

          <Tr>
            <Td style={{ padding: '0' }}>VII</Td>
            <Td style={{ padding: '0' }}>Até 99.840</Td>
            <Td style={{ padding: '0' }}>Até 7.680</Td>
          </Tr>

          <Tr>
            <Td style={{ padding: '0' }}>Especial</Td>
            <Td style={{ padding: '0' }}>Mais de 99.840</Td>
            <Td style={{ padding: '0' }}>Mais de 7. 680</Td>
          </Tr>

          <Tr>
            <Td style={{ padding: '0' }} colSpan="3">
              * Apenas para referência. A capacidade de armazenamento deve
              sempre ser medida em quilogramas de GLP.
            </Td>
          </Tr>
        </tbody>
      </Table>
    </TableWrapper>
  );
};
